import React from 'react';
import MetricCard from '../components/MetricCard';
import SalesChart from '../components/SalesChart';
import styles from '../styles/DashboardPage.module.css';

const metrics = [
  { label: 'Active Users', value: 312 },
  { label: 'Total Orders', value: 1280 },
  { label: 'Low Stock Alerts', value: 7 },
  // { label: 'Total Products', value: 1500 },
  { label: 'Recent Orders', value: 20 },
  { label: 'Pending Shipments', value: 5 },
  { label: 'Order Dispatch', value: 10 },
  { label: 'Delivered Orders', value: 15 },
  { label: 'Cancelled Orders', value: 3 },
];

const recentOrders = [
  { id: 'ORD-1001', customer: 'Ajit Kumar', total: '$120.00', status: 'Shipped' },
  { id: 'ORD-1002', customer: 'Yeshank Singh', total: '$80.00', status: 'Pending' },
  { id: 'ORD-1003', customer: 'Deepak Kumar', total: '$150.00', status: 'Delivered' },
  { id: 'ORD-1004', customer: 'Ravi Shankar', total: '$60.00', status: 'Cancelled' },
];

const statusColors = {
  Shipped: ' black',
  Pending: ' black',
  Delivered: ' black',
  Cancelled: 'Black',
};

const Dashboard = () => (
  <div className={styles.dashboardContainer}>
    <div className={styles.metricsGrid}>
      {metrics.map((m) => (
        <div className={styles.metricCard} key={m.label}>
          <span className={styles.metricValue}>{m.value}</span>
          <span className={styles.metricLabel}>{m.label}</span>
        </div>
      ))}
    </div>
    <div className={styles.chartSectionCard}>
      <h3 className={styles.salesOverviewTitle}>Sales Overview</h3>
      <SalesChart />
    </div>
    <div className={styles.recentOrdersSection}>
      <h3 className={styles.recentOrdersTitle}>Recent Orders</h3>
      <table className={styles.ordersTable}>
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Total</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {recentOrders.map((order, idx) => (
            <tr key={order.id}>
              <td style={{ fontWeight: 500 }}>{order.id}</td>
              <td>{order.customer}</td>
              <td>{order.total}</td>
              <td>
                <span
                  style={{
                    display: 'inline-block',
                    padding: '0.25em 0.9em',
                    borderRadius: '1em',
                    fontWeight: 500,
                    color: 'white',
                    background: statusColors[order.status] || 'white',
                    fontSize: '0.98em',
                    textTransform: 'capitalize',
                    letterSpacing: '0.5px',
                  }}
                >
                  {order.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default Dashboard; 